import { Text } from '@hg/stylizator/typography'
import * as React from 'react'
import styled from 'styled-components'

const PaginateDots: React.FC<React.ComponentProps<typeof Dots>> = (props) => (
  <Dots {...props}>
    <Text type="body" color="currentColor">
      <span>...</span>
    </Text>
  </Dots>
)

export default PaginateDots

const Dots = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  border-radius: 4px;
  color: ${(props) => props.theme.color.gray[50]};
`
